import { customFetch } from "../lib/network/Axios";
import { SocialMediaCampaignMessage, SocialMediaCreativeConfig, SocialMediaTemplateParams } from "../types/socialMediaCampaign.types";

export type SocialMediaCampaignPayload = {
  id?: number;
  title: string;
  templateContent: string;
  // Legacy fields retained for backward compatibility
  contentHtml?: string;
  plainContent?: string;
  imageUrl?: string;
  formatKey?: string;
  creativeConfig?: SocialMediaCreativeConfig;
};

export type SocialMediaCampaignResponse = {
  message: SocialMediaCampaignMessage | null;
  messages?: SocialMediaCampaignMessage[];
  resolvedContent?: string | null;
  templateParams?: SocialMediaTemplateParams | null;
};

export const getSocialMediaCampaignMessage = async (): Promise<SocialMediaCampaignResponse> => {
  const response = await customFetch.get("/social-media-campaign");
  return response.data as SocialMediaCampaignResponse;
};

export const getSocialMediaCampaignMessages = async (): Promise<{ messages: SocialMediaCampaignMessage[] }> => {
  const response = await customFetch.get("/social-media-campaign/list");
  return response.data as { messages: SocialMediaCampaignMessage[] };
};

export const saveSocialMediaCampaignDraft = async (
  payload: SocialMediaCampaignPayload,
): Promise<SocialMediaCampaignMessage> => {
  const response = await customFetch.put("/social-media-campaign/draft", payload);
  return response.data.message as SocialMediaCampaignMessage;
};

export const publishSocialMediaCampaignDraft = async (): Promise<{
  message: SocialMediaCampaignMessage;
  notificationRecipient: string;
}> => {
  const response = await customFetch.post("/social-media-campaign/publish");
  return response.data;
};

export const publishSocialMediaCampaignMessage = async (messageId: number): Promise<{
  message: SocialMediaCampaignMessage;
  notificationRecipient: string;
}> => {
  const response = await customFetch.post(`/social-media-campaign/${messageId}/publish`);
  return response.data;
};

export const unpublishSocialMediaCampaignMessage = async (messageId: number): Promise<{ message: SocialMediaCampaignMessage }> => {
  const response = await customFetch.post(`/social-media-campaign/${messageId}/unpublish`);
  return response.data as { message: SocialMediaCampaignMessage };
};

export const deleteSocialMediaCampaignMessage = async (messageId: number): Promise<{ deleted: boolean; messageId: number }> => {
  const response = await customFetch.delete(`/social-media-campaign/${messageId}`);
  return response.data as { deleted: boolean; messageId: number };
};

export const recordMessageCopy = async (
  messageId: number,
  resolvedContent: string,
  snapshotParams?: SocialMediaTemplateParams | null,
): Promise<{ recorded: boolean; snapshotAt: string }> => {
  const response = await customFetch.post("/social-media-campaign/copy", {
    messageId,
    resolvedContent,
    snapshotParams: snapshotParams ?? undefined,
  });
  return response.data;
};
